export default __webpack_public_path__ + "static/media/rss.ad178c0d.svg";